export default {
  plan: 'Plan',
  continue: 'Continue',
  docs: 'Docs',
  assistViaEmail: 'We will be glad to assist you via email.',
  sendFeedback: 'Please send your questions and feedback to',
  howDoISignUp: 'How do I sign up',
  requiredName: 'Name is a required field en',
  requiredEmail: 'Email is a required field',
  requiredPassword: 'Password is a required field',
  invalidEmail: 'Email is not valid',
  minLengthPassword: 'Password must contain 8 letters or digits',
  invalidPassword:
    'Password should contain one uppercase letter, one lowercase letter, one number, and one special character',
  getStartedWorkoutPlanEmailReminder:
    'To get started, simply go to Fit4me web page, and answer a few quick questions about your workout and nutrition preferences, goals, and overall fitness level. We will also ask for your email: please make sure you&lsquo;ve entered it correctly. Once we have  plan designed just for you, and provide you with the app download link so that you can get started right away.',
  howWillIReceiveMyCustomizedMealAndWorkoutPlan:
    'How will I receive my customized meal and workout plan',
  appDownloadAndAccessInstructions:
    'You`ll receive a unique download link that will take you to the AppStore to download the app. Once the app is installed on your phone, you need to sign into the app using your email. You will have unlimited access to all the features within the app for the duration of your paid period. If you experience any difficulties with downloading or accessing the app, please contact us at',
  planReceiveTime: 'When will I receive my customized meal and workout plan',
  planGenerationDetails:
    'Our smart algorithms are highly precise and are able to customize your fitness plan according to your specific needs. The unique download link will be generated  right after your payment. The plan will become available as soon as you download the app using your unique link.',
  freeTrialQuestion: 'Do we always offer free trials',
  freeTrialInfo:
    'Please note that if a free trial is offered, this will be explicitly stated on the price screen before the checkout. If this is not the case, you will purchase our subscription without a free trial.',
  billingQuestion: 'How will you bill me',
  billingInfo:
    'Generally we offer subscriptions that automatically renew. Depending on what option you choose, your subscription will be renewed at the end of each period.',
  cancelSubscriptionQuestion: 'Can I cancel my subscription',
  cancelSubscriptionInfo:
    'Your subscription renews automatically at the end of each period until you cancel. Note that deleting the app does not cancel your subscriptions. You may cancel a trial or a subscription by Subscription on your iPhone or by email',
  noAccessQuestion: 'I do not have access to my subscription any longer, what happened',
  noAccessInfo:
    'We sometimes offer non-renewing subscriptions that expire after the subscription period (1 month, 3 months or 6 months). Once your chosen subscription expires, you lose access to the app. If you wish to continue using the app after your initial subscription expired, you may repurchase it within the app or on Fit4me web page at any time.',
  loginLabel: 'Login with your email to access your Personal Weight Loss Plan',
  email: 'Email',
  logIn: 'Log In',
  name: 'Name',
  gender: {
    label: 'Gender',
    male: 'male',
    female: 'female',
  },
  dateOfBirth: 'Date of Birth',
  units: {
    label: 'Units',
    kg: 'kg',
    cm: 'cm',
    lbs: 'lbs',
    in: 'in',
    m: 'm',
    ft: 'ft',
  },
  startWeight: 'Start Weight',
  height: 'Height',
  doubleCheckAndRetry: 'Please double-check and try again',
  wrongEmail: 'Oops, wrong email',
  invalidEmailOrPassword: 'Oops, wrong email or password',
  avatar: 'avatar',
  Profile: 'Profile',
  Subscriptions: 'Subscriptions',
  loader: 'loader',
  billingPeriod: 'Billing period',
  subscriptionPrice: 'Subscription price',
  subscriptionCanceled: 'Your subscription has been canceled.',
  noFutureCharges: 'You will not be charged in the future.',
  fullAccessUntilExpires:
    'You will have full access to Fit4Me until your current subscription expires.',
  opps: 'Oops! <br/>Something went wrong.',
  contactUsEmail: 'Contact us via <br/><a href="mailto:{{companyEmail}}">{{companyEmail}}</a>',
  ok: 'ok',
  tooExpensive: "It's too expensive",
  planNotSuitable: "The plan doesn't meet my needs",
  appQualityDisappointment: 'The app quality falls short of my expectations',
  notUsingButMayReturn: "I'm not using the app right now, but I'm open to continuing later",
  goalsAchieved: "I've already achieved my goals",
  technicalIssues: 'There have been technical issues',
  planTooChallenging: 'My personal plan is too challenging to follow',
  avoidAutoRenewalFee: 'I want to avoid the auto-renewal fee',
  forgotPassword: 'Forgot Password?',
  resetPassword: 'Reset Password',
  labelForgot: 'Enter your email to reset your password',
  placeholderEmail: 'Enter your email',
  recoveryEmailSentAt: 'Recovery email sent at',
  pleaseCheckYourInbox: 'Please check your inbox (and spam)',
  sendAgain: 'send again',
  changeEmail: 'change email',
  checkingYouEmail: 'Checking your email',
  agreePrivacyPolicy:
    'By continuing you agree with our <privacy>Privacy Policy</privacy> and <terms>Terms of Use</terms>',
  emailLogin: 'Email login',
  loginToFit4Me: 'Login to Fit4Me',
  enter5DigitCode: 'Enter the 5-digit code sent to your <bold>{{email}}</bold> email address',
  didNotReceiveTheCode: "Didn't receive the code?",
  resendCode: 'Resend code',
  contactSupport: 'Or you can <bold>contact our support</bold>',
  codeResent: 'Code resend! You can request another code in <bold>{{seconds}}s</bold>',
  emailDoesntMatch: "Email login code doesn't match",
  reCheck: 'Re-check the code or request a new one.',
  payments: 'Payments',
  manageSubscription: 'Manage Subscription',
  activeBadge: 'Active',
  paymentMethod: 'Payment method',
  cancelSubscriptionReason: 'Why do you want to cancel?',
  nextChargeDate: 'Next charge date',
  lastChargeDate: 'Last charge date',
  accessUntil: 'Access until',
  renewSubscription: 'Renew Subscription',
  addPaymentMethod: 'Add Payment Method',
  noPaymentTitle: 'No payment methods',
  noPaymentDescription: 'Add a payment method to get started with your subscription',
  canceledStatus: 'Canceled',
  yourFeedbackMatters: 'Your feedback matters!',
  specialOffer: 'Please wait while we generate a special offer.',
  limitedDeal: 'Limited-time deal',
  offerSavings: 'We offer 99% savings for 6 weeks',
  keepWellness: 'Keep your wellness journey going at just 1% of regular cost!',
  dontMissChance:
    "{{name}}, don't miss this chance to continue with Simple's personalized nutrition guidance. After your 3-month savings period, standard quarterly billing ($79.20) resumes automatically.",
  keepPremium: 'Keep Premium',
  cancelSubscriptionBtn: 'Cancel subscription',
  footerText:
    "Remember: You can cancel anytime before April 30, 2025 with no renewal charges. Your 99% discounted rate applies for the full 12-week period. If you choose to continue, your membership will automatically renew at the regular quarterly rate of $79.20 after the promotional period ends. We don't provide refunds for partially used subscription time. To manage or cancel your membership, simply visit your Subscription Management page.",
  prosList: {
    analyzed: 'Analyzed your profile',
    noChange: 'No change to your current billing cycle',
    after: 'After 12 weeks, your subscription is $79.20 quarterly.',
  },
  gotIt: 'Ok, got it',
  weCanceled: "We've canceled your subscription",
  yourSubscriptionIsCanceled:
    "Your Fit4Me subscription is now canceled. No more charges will apply. You'll still have full access until",
  supportForEditional: 'for additional information',
  contact: 'Contact',
  id: 'ID',
  'My account': 'My Account',
  'My Subscriptions': 'My Subscriptions',
  Support: 'Support',
  FAQ: 'FAQ',
  'Cancel Subscription': 'Cancel Subscription',
  'Money-Back Policy': 'Money-Back Policy',
  'Privacy Policy': 'Privacy Policy',
  'Terms of Use': 'Terms of Use',
  'Meals Recommendations': 'Meals Recommendations',
  'Contact Us': 'Contact Us',
}
